<app-auth-card-header>{{ 'Login.Title' | translate }}</app-auth-card-header>

<app-unsupported-browser-warning></app-unsupported-browser-warning>

<form [formGroup]="loginForm" (ngSubmit)="login()">
  <fieldset>
    <!-- Email/Username -->
    <div class="form-group">
      <kj-input
        [formGroup]="loginForm"
        controlName="email"
        name="email"
        iconName="email"
        placeholder="{{ 'Login.Email' | translate }}"
        [autocomplete]="'username'"
      ></kj-input>
    </div>

    <!-- Password -->
    <mat-form-field style="width: 100%">
      <mat-pass-toggle-visibility
        #toggleVisbility
        matSuffix
      ></mat-pass-toggle-visibility>
      <input
        matInput
        [formGroup]="loginForm"
        [formControl]="password"
        controlName="password"
        name="password"
        [type]="toggleVisbility.type"
        required
        placeholder="{{ 'Login.Password' | translate }}"
        autocomplete="current-password"
      />
    </mat-form-field>

    <div class="divider divider-md"></div>

    <button
      mat-raised-button
      color="primary"
      role="button"
      type="submit"
      [disabled]="!loginForm.valid"
      style="display: block; margin: 0 auto;"
    >
      {{ 'Login.Button' | translate }}
    </button>
  </fieldset>
</form>
<app-auth-card-footer>
  <!--<a [routerLink]="['/register']">{{ 'Login.SignUpLink' | translate }}</a>
  <span class="divider-h"></span>-->
  <span class="fake-link" (click)="openDialog()">{{
    'Login.ForgotPasswordLink' | translate
  }}</span>
</app-auth-card-footer>
